import React from "react"
import { Redirect } from 'react-router-dom'
import UserGroupEditContent from '../../../../components/Dashboard/Subscription/UserGroupEditContent'
import Layout from '../../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../../routes'
import { FormLoader } from '../../../../components/Loader/FormLoader'
import { FormattedMessage, useIntl } from 'react-intl'
import { SEO } from '../../../../components/Seo/seo'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { UserGroupProvider } from "../../../../UserGroupContext"
import { userGroups } from '../../../../utils/pages-meta.json'

const SingleUserGroupAdd = () => {
  const intl = useIntl()

  return (
    <>
      <SEO title={intl.formatMessage({ id: 'UserGroups.List.AddUserGroup.Title' })}
        pathname={window.location.origin}
        titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
        image={userGroups.image}
        description={intl.formatMessage({ id: 'UserGroups.List.AddUserGroup.Title' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true} />}
            {!!Object.keys(userData).length &&
              <>
                {!!userData.is_admin ?
                  <Layout content={
                    <UserGroupProvider handleNotificationCall={handleNotificationCall}>
                      <UserGroupEditContent
                        pageTitle={<FormattedMessage id='UserGroups.List.AddUserGroup.Title' />}
                        handleNotificationCall={handleNotificationCall}
                      />
                    </UserGroupProvider>
                  } />
                  :
                  (!userDataLoading && <Redirect to={NamedRoutes.home} />)
                }
              </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default SingleUserGroupAdd